import { NgIf } from '@angular/common';
import { AfterViewInit, Component, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { ImageUploadOptions } from '../image-upload-options';
import { ImageUploaderBaseComponent } from '../image-uploader-base/image-uploader-base.component';

@Component({
  selector: 'curbnturf-image-upload-mobile',
  templateUrl: './image-upload-mobile.component.html',
  styleUrls: ['./image-upload-mobile.component.scss'],
  standalone: true,
  imports: [IonicModule, NgIf, ImageUploaderBaseComponent],
})
export class ImageUploadMobileComponent implements AfterViewInit {
  @Input() options: ImageUploadOptions;

  @Input() croppieImage: string;
  @Input() originalBlob: Blob;
  @Input() maxDimensions: { width: number; height: number };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() saveFunction: (files: any) => void;
  timedShow: boolean = false;

  constructor(private modalController: ModalController) {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.timedShow = true;
    }, 500);
  }

  async close() {
    await this.modalController.dismiss();
  }
}
